export default __webpack_public_path__ + "static/media/angers4.aedc355f.jpg";